import {AxiosError} from 'axios';
import {GET_NOTIFICATION_TEMPLATE_DETAILS_URL} from '../../constants/apiUrls';
import {GET_NOTIFICATION_TEMPLATE_DETAILS_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
interface NotificationTemplateDetailsResponse {
  templateType: string;
  title: string;
  message: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: NotificationTemplateDetailsResponse | any) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetNotificationTemplateDetails = ({onSuccess, onError, uuid, enabled}: Input) => {
  const getNotificationTemplateDetails = async () => {
    const res = await axiosClient.get<NotificationTemplateDetailsResponse | any>(
        GET_NOTIFICATION_TEMPLATE_DETAILS_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NOTIFICATION_TEMPLATE_DETAILS_QUERY_KEY.concat(uuid),
      getNotificationTemplateDetails,
      {
        onSuccess,
        onError,
        enabled,
      }
  );
};
